"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatDropdownOptions;
var _ = require("./");
var _utils = require("../../Filter/utils");
function formatDropdownOptions(options) {
  if ((0, _utils.isMultiLevel)(options)) {
    return (0, _.buildOptions)({
      options: options
    });
  }
  return options;
}